<hlm-dialog [state]="voucherType() ? 'open' : 'closed'" (stateChanged)="onDialogState($event)">
  <hlm-dialog-content *hlmDialogPortal class="max-h-[90vh] max-w-2xl overflow-y-auto">
    <div hlmDialogHeader>
      <h3 hlmDialogTitle>{{ title() }}</h3>
      <p hlmDialogDescription>
        Neue Gutschein-PDFs dieses Typs verwenden ab sofort das gewählte Design. Entwürfe müssen
        zuerst im Editor vervollständigt werden.
      </p>
    </div>

    <ul class="grid gap-3 sm:grid-cols-2">
      @for (design of candidates(); track design.public_id) {
        <li class="rounded-lg border p-3">
          <app-design-thumbnail [design]="design" [alt]="'Vorschau ' + design.name" />
          <div class="mt-2 flex items-center gap-2">
            <span class="min-w-0 flex-1 truncate text-sm font-medium">{{ design.name }}</span>
            @if (design.public_id === activeId()) {
              <span hlmBadge>In Verwendung</span>
            } @else {
              <app-design-issues [issues]="design.activation_issues" />
            }
          </div>
          <p hlmMuted class="text-xs">{{ sizeLabel(design) }}</p>
          <button
            hlmBtn
            size="sm"
            class="mt-2 w-full"
            type="button"
            [variant]="design.public_id === activeId() ? 'outline' : 'default'"
            [disabled]="
              design.public_id === activeId() || !activatable(design) || busyId() !== null
            "
            (click)="choose.emit(design)">
            @if (busyId() === design.public_id) {
              <hlm-spinner />
            }
            {{ design.public_id === activeId() ? 'In Verwendung' : 'Verwenden' }}
          </button>
        </li>
      } @empty {
        <li class="text-muted-foreground col-span-full py-6 text-center text-sm">
          Noch kein Design für diesen Gutschein-Typ.
        </li>
      }
    </ul>

    <div hlmDialogFooter>
      <button hlmBtn variant="outline" type="button" (click)="close.emit()">Schließen</button>
    </div>
  </hlm-dialog-content>
</hlm-dialog>
